import { TApplicationState } from 'shared/types/redux';
import { IPromoInfo } from '../../types/newbuilding/promoInfo';

export function promosSelector(state: TApplicationState): IPromoInfo[] {
  return state.newbuilding.promoInfos;
}
